import { Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updateVariantFlag } from 'connectors/variant-flags/variant-flags.state'
import { localStore } from 'connectors/browser-storage/browser-storage'
import { css } from 'linaria'
import { CollapseWrapper } from './dev-tools'

const variantToolsWrapper = css`
  label {
    font-family: var(--fontSansSerif);
    font-size: var(--fontSize085);
    margin-bottom: var(--spacing025);
  }
  select {
    margin-bottom: var(--spacing050);
  }
  button {
    width: 100%;
  }
`

export function Variants() {
  const allVariants = useSelector((state) => state.variants?._allVariants)
  if (!allVariants) return null
  const variantList = Object.keys(allVariants)

  const resetLocalStorage = () => {
    variantList.forEach((flag) => localStore.removeItem(flag))
    window.location.reload() // reload page
    return false
  }

  return variantList.length ? (
    <div className={variantToolsWrapper}>
      <CollapseWrapper title="Variants">
        {variantList.map((key) => (
          <VariantToggle key={key} title={key} list={allVariants[key]} />
        ))}
        <button onClick={resetLocalStorage}>reset variants</button>
      </CollapseWrapper>
    </div>
  ) : null
}

function VariantToggle({ title, list }) {
  const dispatch = useDispatch()
  const value = useSelector((state) => state.variants[title])

  const handleChange = (event) => {
    const selectedValue = event.currentTarget.value
    dispatch(updateVariantFlag(title, selectedValue))
  }

  return (
    <Fragment>
      <label htmlFor={title}>{title}</label>
      <select id={title} onChange={handleChange} value={value}>
        {list.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </Fragment>
  )
}
